import type { SortState } from '@/types/table';

type ViewWithDefault = { key: string; defaultSort: SortState | null };

/**
 * The view a sort column belongs to: the view whose default sort it is, if
 * any. Today only Completed owns a column (orderCompletedDate), on both the
 * client and the internal registries.
 */
export const sortOwnerView = (
  views: readonly ViewWithDefault[],
  selector: string,
): string | null => views.find((v) => v.defaultSort?.selector === selector)?.key ?? null;

/**
 * Whether a chosen sort still applies on `viewKey`. A sort on a column another
 * view owns only makes sense there (a completion date is empty on every In
 * Progress row, and ascending on All Orders lists every incomplete order
 * first), so it is dropped on a view switch and not restored on other views
 * (DV-3122 review). Every other sort carries across views.
 */
export const sortSurvivesView = (
  views: readonly ViewWithDefault[],
  sort: SortState | null,
  viewKey: string | null,
): boolean => {
  if (!sort) return true;
  const owner = sortOwnerView(views, sort.selector);
  return owner === null || owner === viewKey;
};
